import type {
  ValuationAsset,
  Entity,
  EntityGroup,
  Country,
} from "../types/valuation";
import { getAssetClassification } from "./assetClassifications";

// Entity Group - Single family group
export const generateEntityGroup = (): EntityGroup => ({
  id: "family-001",
  name: "The Henderson Family Group",
  description: "Family wealth management group",
});

// Entities - 5 family members
export const generateEntities = (): Entity[] => [
  {
    id: "entity-001",
    name: "John Henderson",
    entityGroupId: "family-001",
    type: "Individual",
    description: "Head of family",
  },
  {
    id: "entity-002",
    name: "Sarah Henderson",
    entityGroupId: "family-001",
    type: "Individual",
    description: "Spouse",
  },
  {
    id: "entity-003",
    name: "Henderson Family Trust",
    entityGroupId: "family-001",
    type: "Trust",
    description: "Family discretionary trust",
  },
  {
    id: "entity-004",
    name: "Michael Henderson",
    entityGroupId: "family-001",
    type: "Individual",
    description: "Son",
  },
  {
    id: "entity-005",
    name: "Henderson Investment Company",
    entityGroupId: "family-001",
    type: "Company",
    description: "Family investment company",
  },
];

export const generateAssets = (): ValuationAsset[] => {
  const assets: ValuationAsset[] = [
    {
        "id": 1,
        "assetName": "Apple Inc.",
        "entityId": "entity-001",
        "investmentCode": "AAPL",
        "exchange": "NASDAQ",
        "unitsHeld": 500,
        "unitPrice": 175.5,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 625.5,
        "marketValueDomicile": 87750,
        "marketValueReporting": 87750,
        "percentAllocation": 4.85,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 9,
        "country": "USA",
        "reportable": true,
        "portfolioId": 101,
        "portfolioName": "John's Portfolio 1"
    },
    {
        "id": 2,
        "assetName": "Microsoft Corporation",
        "entityId": "entity-001",
        "investmentCode": "MSFT",
        "exchange": "NASDAQ",
        "unitsHeld": 300,
        "unitPrice": 325.75,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 487.5,
        "marketValueDomicile": 97725,
        "marketValueReporting": 97725,
        "percentAllocation": 5.4,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 9,
        "country": "USA",
        "reportable": true,
        "portfolioId": 102,
        "portfolioName": "John's Portfolio 2"
    },
    {
  "id": 3,
  "assetName": "123 Collins Street, Melbourne VIC 3000",
  "entityId": "entity-001",
  "investmentCode": "PROP001",
  "unitsHeld": 1,
  "unitPrice": 850000,
  "priceBaseCurrency": "AUD",
  "priceDate": "2025-09-02",
  "pendingSettlement": 0,
  "accruedIncome": 2125,
  "marketValueDomicile": 850000,
  "marketValueReporting": 850000,
  "percentAllocation": 4.7,
  "isUnitised": false,
  "isMarketAsset": false,
  "assetTypeId": 3,
  "assetSubSectorId": 22,
  "country": "AUS",
  "reportable": true,
  "portfolioId": 101,
  "portfolioName": "John's Portfolio 1"
},
    {
        "id": 4,
        "assetName": "Tesla Inc.",
        "entityId": "entity-001",
        "investmentCode": "TSLA",
        "exchange": "NASDAQ",
        "unitsHeld": 150,
        "unitPrice": 250.3,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 3750,
        "accruedIncome": 0,
        "marketValueDomicile": 37545,
        "marketValueReporting": 37545,
        "percentAllocation": 2.08,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 9,
        "country": "USA",
        "reportable": true,
        "portfolioId": 101,
        "portfolioName": "John's Portfolio 1"
    },
    {
        "id": 5,
        "assetName": "Vanguard Conservative Fund ETF",
        "entityId": "entity-001",
        "investmentCode": "V08AU",
        "exchange": "ASX",
        "unitsHeld": 80,
        "unitPrice": 135.75,
        "priceBaseCurrency": "AUD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 10860,
        "marketValueReporting": 10860,
        "percentAllocation": 0.6,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 5,
        "assetSubSectorId": 27,
        "country": "AUS",
        "reportable": true,
        "portfolioId": 101,
        "portfolioName": "John's Portfolio 1"
    },
    {
        "id": 6,
        "assetName": "Commonwealth of Australia",
        "entityId": "entity-001",
        "investmentCode": "TB161",
        "exchange": "ASX",
        "unitsHeld": 120,
        "unitPrice": 138.4,
        "priceBaseCurrency": "AUD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 16608,
        "marketValueReporting": 16608,
        "percentAllocation": 0.92,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 10,
        "assetSubSectorId": 15,
        "country": "AUS",
        "reportable": true,
        "portfolioId": 101,
        "portfolioName": "John's Portfolio 1"
    },
    {
        "id": 7,
        "assetName": "NVIDIA Corporation",
        "entityId": "entity-001",
        "investmentCode": "NVDA",
        "exchange": "NASDAQ",
        "unitsHeld": 75,
        "unitPrice": 465.2,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 34890,
        "marketValueReporting": 34890,
        "percentAllocation": 1.93,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 9,
        "country": "USA",
        "reportable": true,
        "portfolioId": 101,
        "portfolioName": "John's Portfolio 1"
    },
    {
  "id": 8,
  "assetName": "Unit 15/45 Ocean View Drive, Bondi NSW 2026",
  "entityId": "entity-002",
  "investmentCode": "PROP002",
  "unitsHeld": 1,
  "unitPrice": 1250000,
  "priceBaseCurrency": "AUD",
  "priceDate": "2025-09-02",
  "pendingSettlement": 0,
  "accruedIncome": 3750, // Monthly rent accrued
  "marketValueDomicile": 1250000,
  "marketValueReporting": 1250000,
  "percentAllocation": 6.9,
  "isUnitised": false,
  "isMarketAsset": false,
  "assetTypeId": 3, // Property
  "assetSubSectorId": 22, // Residential Property
  "country": "AUS",
  "reportable": true,
  "portfolioId": 201,
  "portfolioName": "Main"
},
    {
        "id": 9,
        "assetName": "US Treasury Bond 10Y",
        "entityId": "entity-001",
        "investmentCode": "UST10Y",
        "unitsHeld": 50000,
        "unitPrice": 96.75,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 1250,
        "marketValueDomicile": 48375,
        "marketValueReporting": 48375,
        "percentAllocation": 2.67,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 10,
        "assetSubSectorId": 15,
        "country": "USA",
        "reportable": true,
        "portfolioId": 102,
        "portfolioName": "John's Portfolio 2"
    },
    {
        "id": 10,
        "assetName": "Johnson & Johnson",
        "entityId": "entity-001",
        "investmentCode": "JNJ",
        "exchange": "NYSE",
        "unitsHeld": 250,
        "unitPrice": 158.9,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 625,
        "marketValueDomicile": 39725,
        "marketValueReporting": 39725,
        "percentAllocation": 2.2,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 7,
        "country": "USA",
        "reportable": true,
        "portfolioId": 101,
        "portfolioName": "John's Portfolio 1"
    },
    {
        "id": 11,
        "assetName": "Procter & Gamble Co.",
        "entityId": "entity-001",
        "investmentCode": "PG",
        "exchange": "NYSE",
        "unitsHeld": 180,
        "unitPrice": 145.3,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 450,
        "marketValueDomicile": 26154,
        "marketValueReporting": 26154,
        "percentAllocation": 1.45,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 6,
        "country": "USA",
        "reportable": true,
        "portfolioId": 102,
        "portfolioName": "John's Portfolio 2"
    },
    {
        "id": 12,
        "assetName": "Coca-Cola Company",
        "entityId": "entity-001",
        "investmentCode": "KO",
        "exchange": "NYSE",
        "unitsHeld": 400,
        "unitPrice": 58.75,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 600,
        "marketValueDomicile": 23500,
        "marketValueReporting": 23500,
        "percentAllocation": 1.3,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 6,
        "country": "USA",
        "reportable": true,
        "portfolioId": 101,
        "portfolioName": "John's Portfolio 1"
    },
    {
        "id": 13,
        "assetName": "Cash - USD",
        "entityId": "entity-001",
        "priceBaseCurrency": "USD",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 45000,
        "marketValueReporting": 45000,
        "percentAllocation": 2.49,
        "isUnitised": false,
        "isMarketAsset": false,
        "assetTypeId": 2,
        "assetSubSectorId": 19,
        "country": "USA",
        "reportable": true,
        "portfolioId": 101,
        "portfolioName": "John's Portfolio 1"
    },
    {
        "id": 14,
        "assetName": "SPDR Gold Shares",
        "entityId": "entity-001",
        "investmentCode": "GLD",
        "exchange": "NYSE",
        "unitsHeld": 100,
        "unitPrice": 185.9,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 18590,
        "marketValueReporting": 18590,
        "percentAllocation": 1.03,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 5,
        "assetSubSectorId": 29,
        "country": "USA",
        "reportable": true,
        "portfolioId": 101,
        "portfolioName": "John's Portfolio 1"
    },
    {
  "id": 15,
  "assetName": "42 Riverside Terrace, Brisbane QLD 4000",
  "entityId": "entity-003",
  "investmentCode": "PROP003",
  "unitsHeld": 1,
  "unitPrice": 720000,
  "priceBaseCurrency": "AUD",
  "priceDate": "2025-09-02",
  "pendingSettlement": 0,
  "accruedIncome": 1800, // Monthly rent accrued
  "marketValueDomicile": 720000,
  "marketValueReporting": 720000,
  "percentAllocation": 3.98,
  "isUnitised": false,
  "isMarketAsset": false,
  "assetTypeId": 3, // Property
  "assetSubSectorId": 22, // Residential Property
  "country": "AUS",
  "reportable": true,
  "portfolioId": 301,
  "portfolioName": "Portfolio 1"
},
    {
        "id": 16,
        "assetName": "Unilever PLC",
        "entityId": "entity-002",
        "investmentCode": "UL",
        "exchange": "LSE",
        "unitsHeld": 800,
        "unitPrice": 48.75,
        "priceBaseCurrency": "GBP",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 390,
        "marketValueDomicile": 39000,
        "marketValueReporting": 48750,
        "percentAllocation": 2.69,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 6,
        "country": "GBR",
        "reportable": true,
        "portfolioId": 202,
        "portfolioName": "Experimental"
    },
    {
        "id": 17,
        "assetName": "Gateway Plaza Office Tower, Sydney NSW 2000",
        "entityId": "entity-003",
        "investmentCode": "PROP004",
        "unitsHeld": 1,
        "unitPrice": 2850000,
        "priceBaseCurrency": "AUD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 23750, // Monthly commercial rent accrued
        "marketValueDomicile": 2850000,
        "marketValueReporting": 2850000,
        "percentAllocation": 15.75,
        "isUnitised": false,
        "isMarketAsset": false,
        "assetTypeId": 3, // Property
        "assetSubSectorId": 23, // Commercial Property
        "country": "AUS",
        "reportable": true,
        "portfolioId": 301,
        "portfolioName": "Portfolio 1"
    },
    {
        "id": 18,
        "assetName": "Nestlé SA",
        "entityId": "entity-002",
        "investmentCode": "NESN",
        "exchange": "SWX",
        "unitsHeld": 200,
        "unitPrice": 105.2,
        "priceBaseCurrency": "CHF",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 315.6,
        "marketValueDomicile": 21040,
        "marketValueReporting": 23144,
        "percentAllocation": 1.28,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 6,
        "country": "CHE",
        "reportable": true,
        "portfolioId": 201,
        "portfolioName": "Main"
    },
    {
        "id": 19,
        "assetName": "LVMH Moët Hennessy Louis Vuitton",
        "entityId": "entity-002",
        "investmentCode": "MC",
        "exchange": "EPA",
        "unitsHeld": 75,
        "unitPrice": 678.2,
        "priceBaseCurrency": "EUR",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 506.25,
        "marketValueDomicile": 50865,
        "marketValueReporting": 55951.5,
        "percentAllocation": 3.09,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 5,
        "country": "FRA",
        "reportable": true,
        "portfolioId": 203,
        "portfolioName": "Experimental"
    },
    {
        "id": 20,
        "assetName": "Novo Nordisk A/S",
        "entityId": "entity-002",
        "investmentCode": "NVO",
        "exchange": "CPH",
        "unitsHeld": 150,
        "unitPrice": 125.8,
        "priceBaseCurrency": "DKK",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 188.7,
        "marketValueDomicile": 18870,
        "marketValueReporting": 27449.1,
        "percentAllocation": 1.52,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 7,
        "country": "DNK",
        "reportable": true,
        "portfolioId": 202,
        "portfolioName": "Experimental"
    },
    {
        "id": 21,
        "assetName": "UK Government Bond 5Y",
        "entityId": "entity-002",
        "investmentCode": "UKT5Y",
        "exchange": "LSE",
        "unitsHeld": 25000,
        "unitPrice": 99.25,
        "priceBaseCurrency": "GBP",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 625,
        "marketValueDomicile": 24812.5,
        "marketValueReporting": 31015.63,
        "percentAllocation": 1.71,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 10,
        "assetSubSectorId": 15,
        "country": "GBR",
        "reportable": true,
        "portfolioId": 203,
        "portfolioName": "New Investments"
    },
    {
        "id": 22,
        "assetName": "European Real Estate Fund",
        "entityId": "entity-002",
        "investmentCode": "EREF001",
        "unitsHeld": 1000,
        "unitPrice": 125.4,
        "priceBaseCurrency": "EUR",
        "priceDate": "2025-08-30",
        "pendingSettlement": 0,
        "accruedIncome": 631.5,
        "marketValueDomicile": 125400,
        "marketValueReporting": 137940,
        "percentAllocation": 7.62,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 6,
        "assetSubSectorId": 25,
        "country": "EUR",
        "reportable": true,
        "portfolioId": 201,
        "portfolioName": "Main"
    },
    {
        "id": 23,
        "assetName": "Vanguard FTSE Europe ETF",
        "entityId": "entity-002",
        "investmentCode": "VGK",
        "exchange": "NYSE",
        "unitsHeld": 300,
        "unitPrice": 62.45,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 187.35,
        "marketValueDomicile": 18735,
        "marketValueReporting": 18735,
        "percentAllocation": 1.03,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 5,
        "assetSubSectorId": 27,
        "country": "USA",
        "reportable": true,
        "portfolioId": 203,
        "portfolioName": "New Investments"
    },
    {
        "id": 24,
        "assetName": "Cash - GBP",
        "entityId": "entity-002",
        "priceBaseCurrency": "GBP",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 15000,
        "marketValueReporting": 18750,
        "percentAllocation": 1.04,
        "isUnitised": false,
        "isMarketAsset": false,
        "assetTypeId": 2,
        "assetSubSectorId": 19,
        "country": "GBR",
        "reportable": true,
        "portfolioId": 201,
        "portfolioName": "Main"
    },
    {
        "id": 25,
        "assetName": "Cash - EUR",
        "entityId": "entity-002",
        "priceBaseCurrency": "EUR",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 12500,
        "marketValueReporting": 13750,
        "percentAllocation": 0.76,
        "isUnitised": false,
        "isMarketAsset": false,
        "assetTypeId": 2,
        "assetSubSectorId": 19,
        "country": "EUR",
        "reportable": true,
        "portfolioId": 202,
        "portfolioName": "Experimental"
    },
    {
        "id": 26,
        "assetName": "SAP SE",
        "entityId": "entity-002",
        "investmentCode": "SAP",
        "exchange": "XETRA",
        "unitsHeld": 120,
        "unitPrice": 142.3,
        "priceBaseCurrency": "EUR",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 17076,
        "marketValueReporting": 18783.6,
        "percentAllocation": 1.04,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 9,
        "country": "DEU",
        "reportable": true,
        "portfolioId": 203,
        "portfolioName": "New Investments"
    },
    {
        "id": 27,
        "assetName": "ASML Call Options",
        "entityId": "entity-002",
        "investmentCode": "ASML-C750",
        "exchange": "EUREX",
        "unitsHeld": 10,
        "unitPrice": 45.2,
        "priceBaseCurrency": "EUR",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 452,
        "marketValueReporting": 497.2,
        "percentAllocation": 0.03,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 9,
        "country": "NLD",
        "reportable": true,
        "portfolioId": 201,
        "portfolioName": "Main"
    },
    {
        "id": 28,
        "assetName": "Collins Street Retail Complex, Melbourne VIC 3000",
        "entityId": "entity-002",
        "investmentCode": "PROP005",
        "unitsHeld": 1,
        "unitPrice": 1950000,
        "priceBaseCurrency": "AUD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 16250, // Monthly retail rent accrued
        "marketValueDomicile": 1950000,
        "marketValueReporting": 1950000,
        "percentAllocation": 10.78,
        "isUnitised": false,
        "isMarketAsset": false,
        "assetTypeId": 3, // Property
        "assetSubSectorId": 23, // Commercial Property
        "country": "AUS",
        "reportable": true,
        "portfolioId": 201,
        "portfolioName": "Main"
    },
    {
        "id": 29,
        "assetName": "Acacia Ridge Industrial Warehouse, Brisbane QLD 4110",
        "entityId": "entity-003",
        "investmentCode": "PROP006",
        "unitsHeld": 1,
        "unitPrice": 3200000,
        "priceBaseCurrency": "AUD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 22000, // Monthly industrial rent accrued
        "marketValueDomicile": 3200000,
        "marketValueReporting": 3200000,
        "percentAllocation": 17.68,
        "isUnitised": false,
        "isMarketAsset": false,
        "assetTypeId": 3, // Property
        "assetSubSectorId": 41, // Industrial Property (from assetSubSectors.ts id: 41, name: "Development", sectorId: 5)
        "country": "AUS",
        "reportable": true,
        "portfolioId": 304,
        "portfolioName": "Portfolio 4"
    },
    {
        "id": 30,
        "assetName": "Apollo Global Management",
        "entityId": "entity-003",
        "investmentCode": "APO",
        "exchange": "NYSE",
        "unitsHeld": 150,
        "unitPrice": 108.6,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 325.8,
        "marketValueDomicile": 16290,
        "marketValueReporting": 16290,
        "percentAllocation": 0.9,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 8,
        "country": "USA",
        "reportable": true,
        "portfolioId": 302,
        "portfolioName": "Portfolio 2"
    },
    {
        "id": 31,
        "assetName": "Brookfield Asset Management",
        "entityId": "entity-003",
        "investmentCode": "BAM",
        "exchange": "NYSE",
        "unitsHeld": 400,
        "unitPrice": 38.25,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 306,
        "marketValueDomicile": 15300,
        "marketValueReporting": 15300,
        "percentAllocation": 0.85,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 8,
        "country": "USA",
        "reportable": true,
        "portfolioId": 302,
        "portfolioName": "Portfolio 2"
    },
    {
        "id": 32,
        "assetName": "Real Estate Investment Trust",
        "entityId": "entity-003",
        "investmentCode": "REIT001",
        "unitsHeld": 800,
        "unitPrice": 125.5,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-01",
        "pendingSettlement": 0,
        "accruedIncome": 2008,
        "marketValueDomicile": 100400,
        "marketValueReporting": 100400,
        "percentAllocation": 5.55,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 6,
        "assetSubSectorId": 24,
        "country": "USA",
        "reportable": true,
        "portfolioId": 303,
        "portfolioName": "Portfolio 3"
    },
    {
        "id": 33,
        "assetName": "Infrastructure Debt Fund",
        "entityId": "entity-003",
        "investmentCode": "INFRA001",
        "unitsHeld": 500,
        "unitPrice": 98.75,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-08-31",
        "pendingSettlement": 0,
        "accruedIncome": 1185,
        "marketValueDomicile": 49375,
        "marketValueReporting": 49375,
        "percentAllocation": 2.73,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 6,
        "assetSubSectorId": 48,
        "country": "USA",
        "reportable": true,
        "portfolioId": 303,
        "portfolioName": "Portfolio 3"
    },
    {
        "id": 34,
        "assetName": "Private Equity Fund III",
        "entityId": "entity-003",
        "investmentCode": "PE003",
        "unitsHeld": 250,
        "unitPrice": 185.2,
        "priceBaseCurrency": "AUD",
        "priceDate": "2025-06-30",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 46300,
        "marketValueReporting": 46300,
        "percentAllocation": 2.56,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 6,
        "assetSubSectorId": 42,
        "country": "AUS",
        "reportable": true,
        "portfolioId": 304,
        "portfolioName": "Portfolio 4"
    },
    {
        "id": 35,
        "assetName": "Hedge Fund Alpha",
        "entityId": "entity-003",
        "investmentCode": "HF001",
        "unitsHeld": 300,
        "unitPrice": 142.8,
        "priceBaseCurrency": "AUD",
        "priceDate": "2025-08-31",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 42840,
        "marketValueReporting": 42840,
        "percentAllocation": 2.37,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 6,
        "assetSubSectorId": 45,
        "country": "AUS",
        "reportable": true,
        "portfolioId": 304,
        "portfolioName": "Portfolio 4"
    },
    {
        "id": 36,
        "assetName": "Commodities Fund",
        "entityId": "entity-003",
        "investmentCode": "COMM001",
        "unitsHeld": 600,
        "unitPrice": 67.45,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 40470,
        "marketValueReporting": 40470,
        "percentAllocation": 2.24,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 6,
        "assetSubSectorId": 32,
        "country": "USA",
        "reportable": true,
        "portfolioId": 301,
        "portfolioName": "Portfolio 1"
    },
    {
        "id": 37,
        "assetName": "US Corporate Bond Fund",
        "entityId": "entity-003",
        "investmentCode": "USCORP001",
        "unitsHeld": 1000,
        "unitPrice": 96.8,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 1936,
        "marketValueDomicile": 96800,
        "marketValueReporting": 96800,
        "percentAllocation": 5.35,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 9,
        "assetSubSectorId": 14,
        "country": "USA",
        "reportable": true,
        "portfolioId": 303,
        "portfolioName": "Portfolio 3"
    },
    {
        "id": 38,
        "assetName": "High Yield Bond Fund",
        "entityId": "entity-003",
        "investmentCode": "HY001",
        "unitsHeld": 750,
        "unitPrice": 88.6,
        "priceBaseCurrency": "AUD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 1329,
        "marketValueDomicile": 66450,
        "marketValueReporting": 66450,
        "percentAllocation": 3.67,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 9,
        "assetSubSectorId": 36,
        "country": "AUS",
        "reportable": true,
        "portfolioId": 301,
        "portfolioName": "Portfolio 1"
    },
    {
        "id": 39,
        "assetName": "Emerging Markets Debt",
        "entityId": "entity-003",
        "investmentCode": "EMD001",
        "unitsHeld": 500,
        "unitPrice": 75.25,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 752.5,
        "marketValueDomicile": 37625,
        "marketValueReporting": 37625,
        "percentAllocation": 2.08,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 9,
        "assetSubSectorId": 37,
        "country": "USA",
        "reportable": true,
        "portfolioId": 301,
        "portfolioName": "Portfolio 1"
    },
    {
        "id": 40,
        "assetName": "Cash - AUD",
        "entityId": "entity-003",
        "priceBaseCurrency": "AUD",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 75000,
        "marketValueReporting": 75000,
        "percentAllocation": 4.14,
        "isUnitised": false,
        "isMarketAsset": false,
        "assetTypeId": 2,
        "assetSubSectorId": 19,
        "country": "AUS",
        "reportable": true,
        "portfolioId": 301,
        "portfolioName": "Portfolio 1"
    },
    {
        "id": 41,
        "assetName": "Art Investment Fund",
        "entityId": "entity-003",
        "investmentCode": "ART001",
        "unitsHeld": 25,
        "unitPrice": 850,
        "priceBaseCurrency": "AUD",
        "priceDate": "2025-06-30",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 21250,
        "marketValueReporting": 21250,
        "percentAllocation": 1.17,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 21,
        "assetSubSectorId": 1,
        "country": "AUS",
        "reportable": true,
        "portfolioId": 301,
        "portfolioName": "Portfolio 1"
    },
    {
        "id": 42,
        "assetName": "Wine Investment Fund",
        "entityId": "entity-003",
        "investmentCode": "WINE001",
        "unitsHeld": 40,
        "unitPrice": 425.75,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-06-30",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 17030,
        "marketValueReporting": 17030,
        "percentAllocation": 0.94,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 34,
        "assetSubSectorId": 1,
        "country": "USA",
        "reportable": true,
        "portfolioId": 301,
        "portfolioName": "Portfolio 1"
    },
    {
        "id": 43,
        "assetName": "Cryptocurrency Fund",
        "entityId": "entity-003",
        "investmentCode": "CRYPTO001",
        "unitsHeld": 100,
        "unitPrice": 185.4,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 18540,
        "marketValueReporting": 18540,
        "percentAllocation": 1.02,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 27,
        "assetSubSectorId": 28,
        "country": "USA",
        "reportable": true,
        "portfolioId": 302,
        "portfolioName": "Portfolio 2"
    },
    {
        "id": 44,
        "assetName": "Distressed Debt Fund",
        "entityId": "entity-003",
        "investmentCode": "DD001",
        "unitsHeld": 200,
        "unitPrice": 72.8,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-08-31",
        "pendingSettlement": 0,
        "accruedIncome": 291.2,
        "marketValueDomicile": 14560,
        "marketValueReporting": 14560,
        "percentAllocation": 0.8,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 6,
        "assetSubSectorId": 44,
        "country": "USA",
        "reportable": true,
        "portfolioId": 301,
        "portfolioName": "Portfolio 1"
    },
    {
        "id": 45,
        "assetName": "Venture Capital Fund II",
        "entityId": "entity-003",
        "investmentCode": "VC002",
        "unitsHeld": 50,
        "unitPrice": 295.6,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-06-30",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 14780,
        "marketValueReporting": 14780,
        "percentAllocation": 0.82,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 6,
        "assetSubSectorId": 43,
        "country": "USA",
        "reportable": true,
        "portfolioId": 303,
        "portfolioName": "Portfolio 3"
    },
    {
        "id": 46,
        "assetName": "Meta Platforms Inc.",
        "entityId": "entity-004",
        "investmentCode": "META",
        "exchange": "NASDAQ",
        "unitsHeld": 100,
        "unitPrice": 298.75,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 29875,
        "marketValueReporting": 29875,
        "percentAllocation": 1.65,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 9,
        "country": "USA",
        "reportable": true,
        "portfolioId": 401,
        "portfolioName": "Portfolio 1"
    },
    {
        "id": 47,
        "assetName": "Netflix Inc.",
        "entityId": "entity-004",
        "investmentCode": "NFLX",
        "exchange": "NASDAQ",
        "unitsHeld": 50,
        "unitPrice": 425.8,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 21290,
        "marketValueReporting": 21290,
        "percentAllocation": 1.18,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 10,
        "country": "USA",
        "reportable": true,
        "portfolioId": 401,
        "portfolioName": "Portfolio 1"
    },
    {
        "id": 48,
        "assetName": "Advanced Micro Devices",
        "entityId": "entity-004",
        "investmentCode": "AMD",
        "exchange": "NASDAQ",
        "unitsHeld": 200,
        "unitPrice": 142.3,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 2846,
        "accruedIncome": 0,
        "marketValueDomicile": 28460,
        "marketValueReporting": 28460,
        "percentAllocation": 1.57,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 9,
        "country": "USA",
        "reportable": true,
        "portfolioId": 401,
        "portfolioName": "Portfolio 1"
    },
    {
        "id": 49,
        "assetName": "Atlassian Corporation Plc",
        "entityId": "entity-001",
        "investmentCode": "TEAM.AX",
        "exchange": "ASX",
        "unitsHeld": 200,
        "unitPrice": 245.8,
        "priceBaseCurrency": "AUD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 49160,
        "marketValueReporting": 49160,
        "percentAllocation": 2.71,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4, // Equity
        "assetSubSectorId": 9, // Technology
        "country": "AUS",
        "reportable": true,
        "portfolioId": 101,
        "portfolioName": "John's Portfolio 1"
    },
    {
        "id": 50,
        "assetName": "Xero Limited",
        "entityId": "entity-002",
        "investmentCode": "XRO.AX",
        "exchange": "ASX",
        "unitsHeld": 150,
        "unitPrice": 135.4,
        "priceBaseCurrency": "AUD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 20310,
        "marketValueReporting": 20310,
        "percentAllocation": 1.12,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4, // Equity
        "assetSubSectorId": 9, // Technology
        "country": "AUS",
        "reportable": true,
        "portfolioId": 201,
        "portfolioName": "Main"
    },
    {
        "id": 51,
        "assetName": "Afterpay Limited",
        "entityId": "entity-003",
        "investmentCode": "APT.AX",
        "exchange": "ASX",
        "unitsHeld": 300,
        "unitPrice": 95.7,
        "priceBaseCurrency": "AUD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 28710,
        "marketValueReporting": 28710,
        "percentAllocation": 1.59,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4, // Equity
        "assetSubSectorId": 8, // Financial Services
        "country": "AUS",
        "reportable": true,
        "portfolioId": 301,
        "portfolioName": "Portfolio 1"
    },
    {
        "id": 52,
        "assetName": "Cash - USD",
        "entityId": "entity-004",
        "priceBaseCurrency": "USD",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 25000,
        "marketValueReporting": 25000,
        "percentAllocation": 1.38,
        "isUnitised": false,
        "isMarketAsset": false,
        "assetTypeId": 2,
        "assetSubSectorId": 19,
        "country": "USA",
        "reportable": true,
        "portfolioId": 401,
        "portfolioName": "Portfolio 1"
    },
    {
        "id": 53,
        "assetName": "WiseTech Global Limited",
        "entityId": "entity-004",
        "investmentCode": "WTC.AX",
        "exchange": "ASX",
        "unitsHeld": 100,
        "unitPrice": 68.5,
        "priceBaseCurrency": "AUD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 45.6,
        "marketValueDomicile": 6850,
        "marketValueReporting": 6850,
        "percentAllocation": 0.38,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4, // Equity
        "assetSubSectorId": 9, // Technology
        "country": "AUS",
        "reportable": true,
        "portfolioId": 401,
        "portfolioName": "Portfolio 1"
    },
    {
        "id": 54,
        "assetName": "Shopify Inc.",
        "entityId": "entity-005",
        "investmentCode": "SHOP",
        "exchange": "NYSE",
        "unitsHeld": 300,
        "unitPrice": 72.85,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 21855,
        "marketValueReporting": 21855,
        "percentAllocation": 1.21,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 9,
        "country": "USA",
        "reportable": true,
        "portfolioId": 502,
        "portfolioName": "Portfolio 502"
    },
     {
        "id": 55,
        "assetName": "Computershare Limited",
        "entityId": "entity-005",
        "investmentCode": "CPU.AX",
        "exchange": "ASX",
        "unitsHeld": 250,
        "unitPrice": 22.85,
        "priceBaseCurrency": "AUD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 213.5,
        "marketValueDomicile": 5712.5,
        "marketValueReporting": 5712.5,
        "percentAllocation": 0.32,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4, // Equity
        "assetSubSectorId": 9, // Technology
        "country": "AUS",
        "reportable": true,
        "portfolioId": 501,
        "portfolioName": "Portfolio 501"
    },
    {
        "id": 56,
        "assetName": "Technology One Limited",
        "entityId": "entity-001",
        "investmentCode": "TNE.AX",
        "exchange": "ASX",
        "unitsHeld": 400,
        "unitPrice": 12.45,
        "priceBaseCurrency": "AUD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 124.5,
        "marketValueDomicile": 4980,
        "marketValueReporting": 4980,
        "percentAllocation": 0.28,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4, // Equity
        "assetSubSectorId": 9, // Technology
        "country": "AUS",
        "reportable": true,
        "portfolioId": 102,
        "portfolioName": "John's Portfolio 2"
    },
    {
        "id": 57,
        "assetName": "CrowdStrike Holdings",
        "entityId": "entity-005",
        "investmentCode": "CRWD",
        "exchange": "NASDAQ",
        "unitsHeld": 150,
        "unitPrice": 245.6,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 36840,
        "marketValueReporting": 36840,
        "percentAllocation": 2.04,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 9,
        "country": "USA",
        "reportable": true,
        "portfolioId": 503,
        "portfolioName": "Portfolio 503"
    },
    {
        "id": 58,
        "assetName": "Datadog Inc.",
        "entityId": "entity-005",
        "investmentCode": "DDOG",
        "exchange": "NASDAQ",
        "unitsHeld": 200,
        "unitPrice": 108.25,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 21650,
        "marketValueReporting": 21650,
        "percentAllocation": 1.2,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 9,
        "country": "USA",
        "reportable": true,
        "portfolioId": 502,
        "portfolioName": "Portfolio 502"
    },
    {
        "id": 59,
        "assetName": "MongoDB Inc.",
        "entityId": "entity-005",
        "investmentCode": "MDB",
        "exchange": "NASDAQ",
        "unitsHeld": 100,
        "unitPrice": 285.4,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 28540,
        "marketValueReporting": 28540,
        "percentAllocation": 1.58,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 9,
        "country": "USA",
        "reportable": true,
        "portfolioId": 501,
        "portfolioName": "Portfolio 501"
    },
    {
        "id": 60,
        "assetName": "Okta Inc.",
        "entityId": "entity-005",
        "investmentCode": "OKTA",
        "exchange": "NASDAQ",
        "unitsHeld": 175,
        "unitPrice": 78.9,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 13807.5,
        "marketValueReporting": 13807.5,
        "percentAllocation": 0.76,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 9,
        "country": "USA",
        "reportable": true,
        "portfolioId": 501,
        "portfolioName": "Portfolio 501"
    },
    {
        "id": 61,
        "assetName": "ServiceNow Inc.",
        "entityId": "entity-005",
        "investmentCode": "NOW",
        "exchange": "NYSE",
        "unitsHeld": 75,
        "unitPrice": 685.2,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 51390,
        "marketValueReporting": 51390,
        "percentAllocation": 2.84,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 9,
        "country": "USA",
        "reportable": true,
        "portfolioId": 501,
        "portfolioName": "Portfolio 501"
    },
    {
        "id": 62,
        "assetName": "Twilio Inc.",
        "entityId": "entity-005",
        "investmentCode": "TWLO",
        "exchange": "NYSE",
        "unitsHeld": 300,
        "unitPrice": 62.45,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 18735,
        "marketValueReporting": 18735,
        "percentAllocation": 1.03,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 10,
        "country": "USA",
        "reportable": true,
        "portfolioId": 502,
        "portfolioName": "Portfolio 502"
    },
    {
        "id": 63,
        "assetName": "Atlassian Corporation",
        "entityId": "entity-005",
        "investmentCode": "TEAM",
        "exchange": "NASDAQ",
        "unitsHeld": 125,
        "unitPrice": 165.3,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 20662.5,
        "marketValueReporting": 20662.5,
        "percentAllocation": 1.14,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 9,
        "country": "USA",
        "reportable": true,
        "portfolioId": 502,
        "portfolioName": "Portfolio 502"
    },
    {
        "id": 64,
        "assetName": "Slack Technologies",
        "entityId": "entity-005",
        "investmentCode": "WORK",
        "exchange": "NYSE",
        "unitsHeld": 400,
        "unitPrice": 42.75,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 1710,
        "accruedIncome": 0,
        "marketValueDomicile": 17100,
        "marketValueReporting": 17100,
        "percentAllocation": 0.94,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 4,
        "assetSubSectorId": 9,
        "country": "USA",
        "reportable": true,
        "portfolioId": 501,
        "portfolioName": "Portfolio 501"
    },
    {
        "id": 65,
        "assetName": "Cloud Computing ETF",
        "entityId": "entity-005",
        "investmentCode": "SKYY",
        "exchange": "NYSE",
        "unitsHeld": 500,
        "unitPrice": 85.4,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 427,
        "marketValueDomicile": 42700,
        "marketValueReporting": 42700,
        "percentAllocation": 2.36,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 5,
        "assetSubSectorId": 27,
        "country": "USA",
        "reportable": true,
        "portfolioId": 503,
        "portfolioName": "Portfolio 503"
    },
    {
        "id": 66,
        "assetName": "Cybersecurity ETF",
        "entityId": "entity-005",
        "investmentCode": "HACK",
        "exchange": "NYSE",
        "unitsHeld": 300,
        "unitPrice": 58.9,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 176.7,
        "marketValueDomicile": 17670,
        "marketValueReporting": 17670,
        "percentAllocation": 0.98,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 5,
        "assetSubSectorId": 27,
        "country": "USA",
        "reportable": true,
        "portfolioId": 503,
        "portfolioName": "Portfolio 503"
    },
    {
        "id": 67,
        "assetName": "SaaS ETF",
        "entityId": "entity-005",
        "investmentCode": "SaaS",
        "exchange": "NYSE",
        "unitsHeld": 250,
        "unitPrice": 72.6,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 181.5,
        "marketValueDomicile": 18150,
        "marketValueReporting": 18150,
        "percentAllocation": 1,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 5,
        "assetSubSectorId": 27,
        "country": "USA",
        "reportable": true,
        "portfolioId": 502,
        "portfolioName": "Portfolio 502"
    },
    {
        "id": 68,
        "assetName": "Clean Energy ETF",
        "entityId": "entity-005",
        "investmentCode": "ICLN",
        "exchange": "NYSE",
        "unitsHeld": 600,
        "unitPrice": 38.75,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 232.5,
        "marketValueDomicile": 23250,
        "marketValueReporting": 23250,
        "percentAllocation": 1.29,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 5,
        "assetSubSectorId": 2,
        "country": "USA",
        "reportable": true,
        "portfolioId": 501,
        "portfolioName": "Portfolio 501"
    },
    {
        "id": 69,
        "assetName": "Artificial Intelligence ETF",
        "entityId": "entity-005",
        "investmentCode": "BOTZ",
        "exchange": "NYSE",
        "unitsHeld": 400,
        "unitPrice": 48.25,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 193,
        "marketValueDomicile": 19300,
        "marketValueReporting": 19300,
        "percentAllocation": 1.07,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 5,
        "assetSubSectorId": 27,
        "country": "USA",
        "reportable": true,
        "portfolioId": 503,
        "portfolioName": "Portfolio 503"
    },
    {
        "id": 70,
        "assetName": "FinTech ETF",
        "entityId": "entity-005",
        "investmentCode": "FINX",
        "exchange": "NYSE",
        "unitsHeld": 350,
        "unitPrice": 42.8,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 149.8,
        "marketValueDomicile": 14980,
        "marketValueReporting": 14980,
        "percentAllocation": 0.83,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 5,
        "assetSubSectorId": 27,
        "country": "USA",
        "reportable": true,
        "portfolioId": 501,
        "portfolioName": "Portfolio 501"
    },
    {
        "id": 71,
        "assetName": "Blockchain ETF",
        "entityId": "entity-005",
        "investmentCode": "BLOK",
        "exchange": "NYSE",
        "unitsHeld": 200,
        "unitPrice": 28.65,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 57.3,
        "marketValueDomicile": 5730,
        "marketValueReporting": 5730,
        "percentAllocation": 0.32,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 5,
        "assetSubSectorId": 28,
        "country": "USA",
        "reportable": true,
        "portfolioId": 501,
        "portfolioName": "Portfolio 501"
    },
    {
        "id": 72,
        "assetName": "Cash - USD",
        "entityId": "entity-005",
        "priceBaseCurrency": "USD",
        "pendingSettlement": 0,
        "accruedIncome": 0,
        "marketValueDomicile": 55000,
        "marketValueReporting": 55000,
        "percentAllocation": 3.04,
        "isUnitised": false,
        "isMarketAsset": false,
        "assetTypeId": 2,
        "assetSubSectorId": 19,
        "country": "USA",
        "reportable": true,
        "portfolioId": 503,
        "portfolioName": "Portfolio 503"
    },
    {
        "id": 73,
        "assetName": "Growth Stock Fund",
        "entityId": "entity-005",
        "investmentCode": "GROWTH001",
        "unitsHeld": 750,
        "unitPrice": 38.9,
        "priceBaseCurrency": "USD",
        "priceDate": "2025-09-02",
        "pendingSettlement": 0,
        "accruedIncome": 291.75,
        "marketValueDomicile": 29175,
        "marketValueReporting": 29175,
        "percentAllocation": 1.61,
        "isUnitised": true,
        "isMarketAsset": true,
        "assetTypeId": 6,
        "assetSubSectorId": 26,
        "country": "USA",
        "reportable": true,
        "portfolioId": 503,
        "portfolioName": "Portfolio 503"
    }
];
  const assetsWithClassifications = assets.map((asset) => ({
    ...asset,
    classification: getAssetClassification(asset.id),
  }));

  // Recalculate percentages to ensure they sum to 100%
  const totalValue = assetsWithClassifications.reduce(
    (sum, asset) => sum + asset.marketValueReporting,
    0
  );
  assetsWithClassifications.forEach((asset) => {
    asset.percentAllocation = (asset.marketValueReporting / totalValue) * 100;
  });

  return assetsWithClassifications;
};

export const calculateTotalValue = (assets: ValuationAsset[]): number => {
  return assets.reduce((total, asset) => total + asset.marketValueReporting, 0);
};

export const countries = (): Country[] => [
  { id: 1, name: "United States", code: "USA" },
  { id: 2, name: "United Kingdom", code: "GBR" },
  { id: 3, name: "Switzerland", code: "CHE" },
  { id: 4, name: "European", code: "EUR" },
  { id: 5, name: "Denmark", code: "DNK" },
  { id: 6, name: "Netherlands", code: "NLD" },
  { id: 7, name: "France", code: "FRA" },
  { id: 8, name: "Germany", code: "DEU" },
  { id: 9, name: "Australia", code: "AUS" },
];
